import {
  PublicClientApplication,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

let initialized = false;

export const initializeMsal = async () => {
  if (initialized) return;

  await msalInstance.initialize();

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  initialized = true;
};

/**
 * Always get a valid token.
 * If silent fails → redirect.
 */
export const getValidToken = async () => {
  await initializeMsal();

  let account = msalInstance.getActiveAccount();

  if (!account) {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      throw new Error("No authenticated account");
    }
    msalInstance.setActiveAccount(accounts[0]);
    account = accounts[0];
  }

  const request = {
    scopes: [`api://${process.env.REACT_APP_CLIENT_ID}/apilogin`],
    account,
  };

  try {
    const response = await msalInstance.acquireTokenSilent(request);
    return response.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      // 🔥 THIS is the missing piece in your implementation
      await msalInstance.acquireTokenRedirect(request);
      return;
    }

    throw error;
  }
};

export const directLogout = async () => {
  sessionStorage.clear();
  await msalInstance.logoutRedirect();
};